import { Spin } from "antd";
import { BBOT_DJANGO_SERVER } from "Config";
import OPContainer from "top-component-library/OPContainer";

import { useTroveManagement } from "./hooks/useTroveManagement";
import AccountBalanceCard from "./sections/AccountBalanceCard";
import AdminSmsSettingsCard from "./sections/AdminSmsSettingsCard";
import MessageHistoryTable from "./sections/MessageHistoryTable";
import PaymentCard from "./sections/PaymentCard";
import { LegacyLinkAlert } from "./styles";

const TextMessageManagement = (props) => {
  const customerId = props.selectedCustomer?.customer_id;
  const isBbotAdmin = Boolean(props.userInfo?.teams?.includes("bbot"));
  const legacyLink =
    BBOT_DJANGO_SERVER +
    (props.userInfo?.role === "admin" ? "/superuser/console/#!/messaging" : "/owner/console/#!/messaging");

  const { troveId, trove, texts, loading, saving, paying, updateTroveField, saveParams, makeRefill } =
    useTroveManagement(customerId);
  const showBilling = Boolean(trove?.charge_for_sms) || isBbotAdmin;

  return (
    <OPContainer
      title="Text Message Management"
      url="/messaging"
      selectedCustomer={props.selectedCustomer}
      userInfo={props.userInfo}
    >
      <LegacyLinkAlert
        message={
          <span>
            We&apos;ve updated the Text Message Management page. To access the old page, follow this{" "}
            <a href={legacyLink}>link</a>.
          </span>
        }
      />
      <Spin spinning={loading}>
        {!loading && !troveId ? (
          <p>This venue does not have an SMS account configured.</p>
        ) : (
          trove && (
            <>
              {showBilling && <AccountBalanceCard trove={trove} />}
              {isBbotAdmin && (
                <AdminSmsSettingsCard
                  trove={trove}
                  saving={saving}
                  onUpdateField={updateTroveField}
                  onSave={saveParams}
                />
              )}
              {showBilling && (
                <PaymentCard
                  trove={trove}
                  saving={saving}
                  paying={paying}
                  onUpdateField={updateTroveField}
                  onSave={saveParams}
                  onManualRefill={makeRefill}
                />
              )}
              <MessageHistoryTable texts={texts} showCost={showBilling} />
            </>
          )
        )}
      </Spin>
    </OPContainer>
  );
};

export default TextMessageManagement;
